import { scope } from '../../constants';

export const GET_PLAN = `${scope}GET_PLAN`;
export const FETCH_PLAN = `${scope}FETCH_PLAN`;
export const SET_PLAN = `${scope}SET_PLAN`;
export const GET_PLAN_FOLDER = `${scope}GET_PLAN_FOLDER`;
export const SET_PLAN_FOLDER = `${scope}SET_PLAN_FOLDER`;
